export default __webpack_public_path__ + "static/media/saumya.8ef840f1.jpeg";